module.exports = __webpack_public_path__ + "static/media/1001420TL.d3751d87.jpg";